import { render, staticRenderFns } from "./MissedCallMenu.vue?vue&type=template&id=92eb0f04&scoped=true&"
import script from "./MissedCallMenu.vue?vue&type=script&lang=js&"
export * from "./MissedCallMenu.vue?vue&type=script&lang=js&"
import style0 from "./MissedCallMenu.vue?vue&type=style&index=0&id=92eb0f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92eb0f04",
  null
  
)

export default component.exports